import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect, useId } from "react";
const DEFAULT_METABALL_COLORS = {
  from: "#FFAE00",
  to: "#FF2D75"
};
const MetaballBlob = ({ level, size, colors }) => {
  const t = useRef(0);
  const [circles, setCircles] = useState([]);
  useEffect(() => {
    let raf;
    const N = 5;
    const tick = () => {
      t.current += 0.015;
      const c2 = [];
      for (let i = 0; i < N; i++) {
        const a = i / N * Math.PI * 2 + t.current * 0.4;
        const r = 12 + level * 14;
        const dist = 14 + Math.sin(t.current * 1.2 + i) * 6 + level * 12;
        c2.push({
          cx: 50 + Math.cos(a) * dist,
          cy: 50 + Math.sin(a) * dist,
          r
        });
      }
      c2.push({ cx: 50, cy: 50, r: 18 + level * 8 });
      setCircles(c2);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [level]);
  const c = colors ?? DEFAULT_METABALL_COLORS;
  const uid = useId().replace(/:/g, "");
  const filterId = `voice-meta-goo-${uid}`;
  const gradId = `voice-meta-g-${uid}`;
  return /* @__PURE__ */ jsxs("svg", { width: size, height: size, viewBox: "0 0 100 100", "aria-hidden": true, children: [
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs("filter", { id: filterId, children: [
        /* @__PURE__ */ jsx("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "2.2", result: "blur" }),
        /* @__PURE__ */ jsx("feColorMatrix", { in: "blur", mode: "matrix", values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" })
      ] }),
      /* @__PURE__ */ jsxs("linearGradient", { id: gradId, x1: "0", y1: "0", x2: "1", y2: "1", children: [
        /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: c.from }),
        /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: c.to })
      ] })
    ] }),
    /* @__PURE__ */ jsx("g", { filter: `url(#${filterId})`, children: circles.map((circ, i) => /* @__PURE__ */ jsx("circle", { cx: circ.cx, cy: circ.cy, r: circ.r, fill: `url(#${gradId})` }, i)) })
  ] });
};
export {
  MetaballBlob
};
//# sourceMappingURL=MetaballBlob.js.map
